export enum StepId {
  Welcome = 'welcome',
  Category = 'category',
  Theme = 'theme',
  SetupStore = 'setup-store',
  StoreName = 'store-name',
  LaunchStore = 'launch-store',
  SitePreview = 'site-preview',
  MinimalSetup = 'minimal-setup',
  PostPurchase = 'post-purchase',
  RegisterCompleted = 'register-completed',
}

export enum ActionId {
  WelcomeNext = 'welcome-next',
  CategoryNext = 'category-next',
  ThemeNext = 'theme-next',
  StoreNameNext = 'store-name-next',
}
